import PropTypes from 'prop-types';
import Image from 'next/image';
import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { grey } from '@mui/material/colors';

import CustomContainer from 'components/Shared/CustomContainer';
import StandardCTA from 'components/Buttons/StandardCTA';

import { warrantyContent as mock } from 'mocks/techVertical';

import { handleSuccessButton } from 'utils/planUtils';

Warranty.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        imageUrl: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
};

Warranty.defaultProps = {
  content: mock,
};

export default function Warranty({ content }) {
  const theme = useTheme();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box component="section" bgcolor={grey[900]}>
      <CustomContainer>
        <Typography
          color="background.paper"
          fontWeight={700}
          mb={4}
          textAlign="center"
          variant={mobileBreakpoint ? 'h6' : 'h4'}
        >
          Dupla garantia
        </Typography>

        <Typography
          color="background.paper"
          mb={4}
          textAlign="center"
          variant={mobileBreakpoint ? 'body1' : 'subtitle1'}
        >
          A Fluencypass tem tudo o que você precisa para falar inglês de uma vez
          por todas.
        </Typography>

        <Grid container alignItems="center" spacing={4}>
          {content.content.map((warranty) => (
            <Grid item key={warranty.imageUrl} xs={12} md={6}>
              <Box
                alignItems={{ xs: 'flex-start', md: 'center' }}
                display="flex"
                gap={2}
                maxWidth={539}
                mx="auto"
              >
                <Image
                  alt="ícone conversação"
                  height={mobileBreakpoint ? 120 : 180}
                  loader={({ src, width }) => `${src}?w=${width}`}
                  src={`/assets/svg/tech-vertical/${warranty.imageUrl}.svg`}
                  width={mobileBreakpoint ? 120 : 180}
                />

                <Typography variant="body1" color="background.paper">
                  {warranty.text}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box mt={8} textAlign="center">
          <StandardCTA
            text="Quero o tech english"
            onClick={handleSuccessButton}
          />
        </Box>
      </CustomContainer>
    </Box>
  );
}
